import { render, staticRenderFns } from "./Portfolios.html?vue&type=template&id=612462f4&scoped=true&"
import script from "./Portfolios.js?vue&type=script&lang=js&"
export * from "./Portfolios.js?vue&type=script&lang=js&"
import style0 from "./Portfolios.scss?vue&type=style&index=0&id=612462f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612462f4",
  null
  
)

export default component.exports